import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { CTAButton } from './CTAButton';
const benefits = ['Implement in 24 hours — the sprint guide is included', 'Works in any market condition, in any of 12 countries', '7-day money-back guarantee, no questions asked'];
export function FinalCTASection() {
  return <section id="get-access" className="relative w-full overflow-hidden bg-navy-800 py-20 lg:py-28" aria-labelledby="cta-heading" data-id="element-27" data-mp="v3hxhripzas">
      <div aria-hidden="true" className="pointer-events-none absolute -left-40 top-0 h-[520px] w-[520px] rounded-full bg-navy-700 opacity-70 blur-3xl animate-drift" data-id="element-28" data-mp="34clegt1ubjvw" />
      <div aria-hidden="true" className="pointer-events-none absolute -right-32 bottom-0 h-[420px] w-[420px] rounded-full bg-brand-gold/10 blur-3xl animate-drift" data-id="element-29" data-mp="39adfcckgqgc8" />

      <div className="relative mx-auto max-w-3xl px-6 text-center lg:px-8" data-id="element-30" data-mp="2gly3fywmoe54">
        <Reveal data-id="element-31" data-mp="2llu53rhurthi">
          <h2 id="cta-heading" className="text-3xl font-black leading-tight tracking-tight text-white sm:text-4xl lg:text-5xl" data-id="element-32" data-mp="2llaoqf7upd5l">
            Ready to dominate your market?
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-lg leading-relaxed text-slate-300" data-id="element-33" data-mp="21vec3z7ly3gs">
            Join 2,000+ agents who&rsquo;ve already transformed their business with AI.
          </p>

          <ul className="mt-8 inline-flex flex-col items-start gap-3 text-left" data-id="element-34" data-mp="1s6e821e90hvq">
            {benefits.map(benefit => <li key={benefit} className="flex items-start gap-3 text-[15px] font-medium text-slate-200" data-id="element-35" data-mp="1o52h9sjn1qly">
                <CheckIcon aria-hidden="true" className="mt-0.5 h-5 w-5 shrink-0 text-brand-gold" data-id="element-36" data-mp="1j56nsn8khhkn" />
                {benefit}
              </li>)}
          </ul>

          <div className="mt-10" data-id="element-37" data-mp="1e86hcb7t2ct0">
            <CTAButton href="https://the-real-estate-growth-system.impultienda.ar/checkout" data-id="element-38" data-mp="197sb8yprlcxm">GET THE SYSTEM NOW — $24 USD</CTAButton>
            <p className="mt-4 text-sm text-slate-400" data-id="element-39" data-mp="38junpozz171s">
              Limited time: includes all 5 bonuses{' '}
              <span className="font-semibold text-brand-gold" data-id="element-40" data-mp="33m2vetvezix2">free</span>.
            </p>
          </div>
        </Reveal>

      </div>
    </section>;
}